<template>
  <div class="listing-form categories-information margin-auto">
    <Card class="categories-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-link"/>
        <div><p style="color:#000;font-weight:bold">Categories</p></div>
      </div>
      <div>
        <Form ref="CategoriesInformationForm" :model="value" :rules="formRules" label-position="top">
          <FormItem prop="newcategory">
            <span slot="label">
              <span style="color:#ed4014;font-family:SimSun;margin-right:4px;line-height:1;">*</span>
              Categories
            </span>
            <KSelect v-model="value.newcategory" :isFilterable="true" :isMultiple="true" class="k-select" :optionList="categoryList"/>
          </FormItem>
          <FormItem>
            <span slot="label">
              <span style="color:#ed4014;font-family:SimSun;margin-right:4px;line-height:1;">*</span>
              Your technology is optimal for which application?
              <!-- <Tooltip max-width="300" placement="top" content="Select 8 maximum">[?]</Tooltip> -->
            </span>
            <KSelect v-model="value.marketapplication" :optionList="marketApplicationList" :isFilterable="true" :isMultiple="true" class="k-select"/>
          </FormItem>
          <FormItem label="Other application">
            <Input class="k-input" v-model="value.other_services"/>
          </FormItem>
          <FormItem prop="tags">
            <span slot="label">
              Tags
              <Tooltip max-width="300" placement="top" content="10 keywords max. separated by a comma">[?]</Tooltip>
            </span>
            <Input v-model="value.tags" class="k-input"/>
          </FormItem>
          <FormItem label="Downloads" prop="file_download">
            <div class="d-flex-center">
              <UploadFile class="file-upload" @upload="(file, name) => {value.file_download.push({file:file,file_name:name}) }" :multiple="true" :format="['pdf']" :maxSize="102400">
                <div slot="content">
                  <div class="drag-photo clickable" style="padding: 40px 60px; border: 1px dashed #ccc;">
                    <Icon type="md-cloud-upload" size="20" color="#ccc"/>
                  </div>
                </div>
              </UploadFile>
              <div v-if="value.file_download.length" class="d-flex-center">
                <div v-for="(file, idx) in value.file_download" :key="idx" class="pos-relative" style="margin-left:10px;">
                  <Icon type="md-trash" color="#ed4014" class="clickable" @click="value.file_download.splice(idx, 1)" style="position:absolute;z-index:9;color:#ffffff;background:red;border-radius:50%;padding:5px;right:5px;bottom:5px;"/>
                  <Avatar shape="square" icon="ios-document" size="110" />
                </div>
              </div>
            </div>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { fetchCategories } from '@/services/categories'
import { fetchMarketApplications } from '@/services/market-applications'
import KSelect from '@/components/ui/Select'
import UploadFile from '@/components/ui/UploadFile'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    KSelect,
    UploadFile
  },

  data () {
    const validateCategories = (rule, value, callback) => {
      if (value.length < 1 || value === '') {
        callback(new Error('Please select the categories'))
      } else {
        callback()
      }
    }
    return {
      categoryList: [],
      marketApplicationList: [],
      formRules: {
        newcategory: [
          { validator: validateCategories, trigger: 'change' }
        ]
      }
    }
  },

  mounted () {
    this.getCategories()
    this.getMarketApplications()
  },

  methods: {
    getCategories () {
      fetchCategories().then(res => {
        if (res.data.results && res.data.results.length > 0) {
          this.categoryList = res.data.results.reduce((acc, cur) => {
            acc.push({
              value: cur.id,
              label: cur.name
            })
            if (cur.subcategories.length > 0) {
              cur.subcategories.map(item => {
                acc.push({
                  value: item.id,
                  label: '_ ' + item.name
                })
                if (item.subcategories && item.subcategories.length > 0) {
                  item.subcategories.map(item => {
                    acc.push({
                      value: item.id,
                      label: '_ _ ' + item.name
                    })
                  })
                }
              })
            }
            return acc
          }, [])
        } else {
          this.categoryList = []
        }
      }).catch(err => {
        console.log('Failed to fetch tech categories: ', err)
      })
    },

    getMarketApplications () {
      this.isLoading = true
      fetchMarketApplications().then(res => {
        this.marketApplicationList = res.data.results.reduce((acc, cur) => {
          acc.push({
            value: cur.id,
            label: cur.name
          })
          return acc
        }, [])
      }).catch(err => {
        console.log('Failed to get market applications: ', err)
      })
    },

    handleSubmit () {
      this.$refs.CategoriesInformationForm.validate((valid) => {
        if (valid) {
          this.$emit('success', true)
        } else {
          this.$emit('success', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.categories-information {
  max-width:700px;
  .categories-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.categories-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
